'use client';
"use strict";

var _excluded = ["startColor", "endColor", "isLoaded", "fadeDuration", "speed", "className", "fitContent"],
  _excluded2 = ["noOfLines", "spacing", "skeletonHeight", "className", "startColor", "endColor", "isLoaded", "fadeDuration", "speed", "variant", "size", "colorScheme", "children"],
  _excluded3 = ["size"];
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Skeleton: function Skeleton() {
    return _Skeleton;
  },
  SkeletonCircle: function SkeletonCircle() {
    return _SkeletonCircle;
  },
  SkeletonText: function SkeletonText() {
    return _SkeletonText;
  }
});
module.exports = __toCommonJS(src_exports);

// src/skeleton.tsx
var import_react_use_previous = require("@chakra-ui/react-use-previous");
var import_shared_utils = require("@chakra-ui/shared-utils");
var import_system = require("@chakra-ui/system");

// src/use-is-first-render.ts
var import_react = require("react");
function useIsFirstRender() {
  var isFirstRender = (0, import_react.useRef)(true);
  (0, import_react.useEffect)(function () {
    isFirstRender.current = false;
  }, []);
  return isFirstRender.current;
}

// src/skeleton.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var StyledSkeleton = (0, import_system.chakra)("div", {
  baseStyle: {
    boxShadow: "none",
    backgroundClip: "padding-box",
    cursor: "default",
    color: "transparent",
    pointerEvents: "none",
    userSelect: "none",
    "&::before, &::after, *": {
      visibility: "hidden"
    }
  }
});
var $startColor = (0, import_system.cssVar)("skeleton-start-color");
var $endColor = (0, import_system.cssVar)("skeleton-end-color");
var fade = (0, import_system.keyframes)({
  from: {
    opacity: 0
  },
  to: {
    opacity: 1
  }
});
var bgFade = (0, import_system.keyframes)({
  from: {
    borderColor: $startColor.reference,
    background: $startColor.reference
  },
  to: {
    borderColor: $endColor.reference,
    background: $endColor.reference
  }
});
var _Skeleton = (0, import_system.forwardRef)(function (props, ref) {
  var skeletonProps = _objectSpread(_objectSpread({}, props), {}, {
    fadeDuration: typeof props.fadeDuration === "number" ? props.fadeDuration : 0.4,
    speed: typeof props.speed === "number" ? props.speed : 0.8
  });
  var styles = (0, import_system.useStyleConfig)("Skeleton", skeletonProps);
  var isFirstRender = useIsFirstRender();
  var _ref = (0, import_system.omitThemingProps)(skeletonProps),
    _ref$startColor = _ref.startColor,
    startColor = _ref$startColor === void 0 ? "" : _ref$startColor,
    _ref$endColor = _ref.endColor,
    endColor = _ref$endColor === void 0 ? "" : _ref$endColor,
    isLoaded = _ref.isLoaded,
    fadeDuration = _ref.fadeDuration,
    speed = _ref.speed,
    className = _ref.className,
    fitContent = _ref.fitContent,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _ref2 = (0, import_system.useToken)("colors", [startColor, endColor]),
    _ref3 = _slicedToArray(_ref2, 2),
    startColorVar = _ref3[0],
    endColorVar = _ref3[1];
  var wasPreviouslyLoaded = (0, import_react_use_previous.usePrevious)(isLoaded);
  var _className = (0, import_shared_utils.cx)("chakra-skeleton", className);
  var cssVarStyles = _objectSpread(_objectSpread({}, startColorVar && _defineProperty({}, $startColor.variable, startColorVar)), endColorVar && _defineProperty({}, $endColor.variable, endColorVar));
  if (isLoaded) {
    var animation = isFirstRender || wasPreviouslyLoaded ? "none" : "".concat(fade, " ").concat(fadeDuration, "s");
    return /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_system.chakra.div, _objectSpread({
      ref: ref,
      className: _className,
      __css: {
        animation: animation
      }
    }, rest));
  }
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(StyledSkeleton, _objectSpread(_objectSpread({
    ref: ref,
    className: _className
  }, rest), {}, {
    __css: _objectSpread(_objectSpread(_objectSpread({
      width: fitContent ? "fit-content" : void 0
    }, styles), cssVarStyles), {}, {
      _dark: _objectSpread(_objectSpread({}, styles["_dark"]), cssVarStyles),
      animation: "".concat(speed, "s linear infinite alternate ").concat(bgFade)
    })
  }));
});
_Skeleton.displayName = "Skeleton";

// src/skeleton-text.tsx
var import_media_query = require("@chakra-ui/media-query");
var import_system2 = require("@chakra-ui/system");
var import_shared_utils2 = require("@chakra-ui/shared-utils");
var import_jsx_runtime2 = require("react/jsx-runtime");
function range(count) {
  return Array(count).fill(1).map(function (_, index) {
    return index + 1;
  });
}
var defaultNoOfLines = 3;
var _SkeletonText = function _SkeletonText(props) {
  var _props$noOfLines = props.noOfLines,
    noOfLines = _props$noOfLines === void 0 ? defaultNoOfLines : _props$noOfLines,
    _props$spacing = props.spacing,
    spacing = _props$spacing === void 0 ? "0.5rem" : _props$spacing,
    _props$skeletonHeight = props.skeletonHeight,
    skeletonHeight = _props$skeletonHeight === void 0 ? "0.5rem" : _props$skeletonHeight,
    className = props.className,
    startColor = props.startColor,
    endColor = props.endColor,
    isLoaded = props.isLoaded,
    fadeDuration = props.fadeDuration,
    speed = props.speed,
    variant = props.variant,
    size = props.size,
    colorScheme = props.colorScheme,
    children = props.children,
    rest = _objectWithoutProperties(props, _excluded2);
  var noOfLinesValue = (0, import_media_query.useBreakpointValue)(typeof noOfLines === "number" ? [noOfLines] : noOfLines) || defaultNoOfLines;
  var numbers = range(noOfLinesValue);
  var getWidth = function getWidth(index) {
    if (noOfLinesValue > 1) {
      return index === numbers.length ? "80%" : "100%";
    }
    return "100%";
  };
  var _className = (0, import_shared_utils2.cx)("chakra-skeleton__group", className);
  return /* @__PURE__ */(0, import_jsx_runtime2.jsx)(import_system2.chakra.div, _objectSpread(_objectSpread({
    className: _className
  }, rest), {}, {
    children: numbers.map(function (number, index) {
      if (isLoaded && index > 0) {
        return null;
      }
      var sizeProps = isLoaded ? null : {
        mb: number === numbers.length ? "0" : spacing,
        width: getWidth(number),
        height: skeletonHeight
      };
      return /* @__PURE__ */(0, import_jsx_runtime2.jsx)(_Skeleton, _objectSpread(_objectSpread({
        startColor: startColor,
        endColor: endColor,
        isLoaded: isLoaded,
        fadeDuration: fadeDuration,
        speed: speed,
        variant: variant,
        size: size,
        colorScheme: colorScheme
      }, sizeProps), {}, {
        // allows animating the children
        children: index === 0 ? children : void 0
      }), numbers.length.toString() + number);
    })
  }));
};
_SkeletonText.displayName = "SkeletonText";

// src/skeleton-circle.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var _SkeletonCircle = function _SkeletonCircle(_ref6) {
  var _ref6$size = _ref6.size,
    size = _ref6$size === void 0 ? "2rem" : _ref6$size,
    rest = _objectWithoutProperties(_ref6, _excluded3);
  return /* @__PURE__ */(0, import_jsx_runtime3.jsx)(_Skeleton, _objectSpread({
    borderRadius: "full",
    boxSize: size
  }, rest));
};
_SkeletonCircle.displayName = "SkeletonCircle";
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Skeleton: _Skeleton,
  SkeletonCircle: _SkeletonCircle,
  SkeletonText: _SkeletonText
});